(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('videoIntroduction', VideoIntroduction)

    /** @ngInject */
    function VideoIntroduction($timeout, $rootScope, HelperService, PATHS) {
        function VideoIntroductionController() {
            const vm = this;

            vm.onSelectVideo = video => {
                HelperService.startLoading('.embed-loader');

                vm.selectedVideo = video;

                $timeout(() => {
                    HelperService.stopLoading('.embed-loader');
                }, 250);
            }

            vm.closeIntroduction = () => {
                $rootScope.showIntroduction = !$rootScope.showIntroduction;
            }

            init();

            function init() {
                vm.selectedVideo = 'https://www.youtube.com/embed/zvE9Iy70gTo';
            }
        }

        return {
            bindToController: true,
            controller: VideoIntroductionController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/video-introduction/video-introduction.html`,
            scope: {
                show: '='
            }
        }
    }
}());